import * as React from 'react';
import { cn } from '@/lib/utils';

const EssayPage = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-essay-page', 'flex w-full flex-wrap justify-between gap-11', className)}
    {...props}
  />
));
EssayPage.displayName = 'EssayPage';

const EssayPageMain = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-essay-page-main', 'flex-1', className)}
    {...props}
  />
));
EssayPageMain.displayName = 'EssayPageMain';

const EssayPageSidebar = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-essay-page-sidebar', 'w-80 max-w-full', className)}
    {...props}
  />
));
EssayPageSidebar.displayName = 'EssayPageSidebar';

const EssayPageSidebarSkill = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-essay-page-sidebar-skill', 'hidden w-80 xl:block', className)}
    {...props}
  />
));
EssayPageSidebarSkill.displayName = 'EssayPageSidebarSkill';

const EssayPageCardScore = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-essay-page-card-score',
      'mb-3 rounded-xl border-2 border-solid border-[var(--color-neutral-bright,#f1f5fa)] bg-[linear-gradient(10deg,#fff_20.02%,#f5f5f5_85.13%)] p-8 text-center shadow-[0px_4px_10px_0px_rgba(119,119,120,0.15)]',
      className
    )}
    {...props}
  />
));
EssayPageCardScore.displayName = 'EssayPageCardScore';

const EssayPageCardScoreValue = React.forwardRef(({ className, variant = 'success', ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-essay-page-card-score-value',
      // styles
      'mb-0 text-4xl font-extrabold text-neutral-dark',
      variant === 'success' && 'text-success',
      variant === 'danger' && 'text-danger',
      variant === 'warning' && 'text-warning',
      className
    )}
    {...props}
  />
));
EssayPageCardScoreValue.displayName = 'EssayPageCardScoreValue';

const EssayPageTia = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-essay-page-tia',
      // styles
      'mb-6 flex justify-center gap-6',
      className
    )}
    {...props}
  />
));
EssayPageTia.displayName = 'EssayPageTia';

const EssayPageTiaContent = React.forwardRef(({ className, arrowPosition = 'left', ...props }, ref) => {
  // Estilos base do container: borda neutra e fundo branco
  const baseStyles = 'relative flex-grow border border-solid border-neutral-lightest bg-white p-3 md:p-6';

  // Lógica de arredondamento condicional:
  // Se for top-left, arredonda tudo (rounded-lg).
  // Se for left (ou qualquer outro), arredonda apenas os outros 3 cantos.
  const radiusStyles = arrowPosition === 'top-left' ? 'rounded-lg' : 'rounded-tr-lg rounded-br-lg rounded-bl-lg';

  // Estilos da Seta na Esquerda
  const arrowLeftStyles = [
    'before:absolute before:left-[-16px] before:top-[-17px] before:h-0 before:w-0 before:rotate-[136deg] before:border-[16px] before:border-transparent before:border-r-neutral-lightest',
    'after:absolute after:left-[-14px] after:top-[-16px] after:h-0 after:w-0 after:rotate-[136deg] after:border-[16px] after:border-transparent after:border-r-white'
  ];

  // Estilos da Seta para Cima (Variante com borda neutral-lightest)
  const arrowTopLeftStyles = [
    'before:absolute before:left-[12px] before:top-[-32px] before:h-0 before:w-0 before:border-[16px] before:border-transparent before:border-b-neutral-lightest',
    'after:absolute after:left-[12px] after:top-[-31px] after:h-0 after:w-0 after:border-[16px] after:border-transparent after:border-b-white'
  ];

  return (
    <div
      ref={ref}
      className={cn('c-essay-page-tia-content', baseStyles, radiusStyles, arrowPosition === 'left' ? arrowLeftStyles : arrowTopLeftStyles, className)}
      {...props}
    />
  );
});

EssayPageTiaContent.displayName = 'EssayPageTiaContent';

const EssayPageTiaHeader = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'c-essay-page-tia-header',
        // styles
        'mb-3 flex items-center justify-between font-bold',
        className
      )}
      {...props}
    />
  );
});

EssayPageTiaHeader.displayName = 'EssayPageTiaHeader';

const EssayPageTimelineHeader = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'c-essay-page-timeline-header',
        // styles
        'flex items-center justify-between font-bold',
        className
      )}
      {...props}
    />
  );
});

EssayPageTimelineHeader.displayName = 'EssayPageTimelineHeader';

const EssayPageTimelineTitle = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn(
        'c-essay-page-timeline-title',
        // styles
        'block py-6 font-bold',
        className
      )}
      {...props}
    />
  );
});

EssayPageTimelineTitle.displayName = 'EssayPageTimelineTitle';

export { EssayPage, EssayPageMain, EssayPageSidebar, EssayPageSidebarSkill, EssayPageCardScore, EssayPageCardScoreValue, EssayPageTia, EssayPageTiaContent, EssayPageTiaHeader, EssayPageTimelineHeader, EssayPageTimelineTitle };
